import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";

export interface Marcador {
  id: string;
  cor: string | undefined;
  descricao?: string | null;
  usuario: UsuarioList;
  ativo?: boolean;
  dataHoraCriacao?: Date | string;
}

export const ISmarcador: Marcador = {
  id: "",
  cor: "",
  descricao: "",
  usuario: ISusuarioList,
  ativo: false,
  dataHoraCriacao: "",

}